
import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionType from '@/controllers/options/DeliveryOptionTypeEnum';
import DeliveryOptionUtility from '@/controllers/options/DeliveryOptionUtility';
import ToolManager from '@/controllers/tools/ToolManager';
import { inject } from 'vue';
import { Prop, Vue, Options, Watch } from 'vue-property-decorator';
import RegularToolbarItem from './RegularToolbarItem.vue';
import TextToSpeechItem from './TextToSpeechItem.vue';
@Options({
  components: { RegularToolbarItem, TextToSpeechItem },
})
export default class ItemToolbar extends Vue {
  private toolManager: ToolManager | undefined = inject<ToolManager>('toolManager');
  private basicDeliveryOptions_: Array<DeliveryOption> = new Array<DeliveryOption>();
  private textToSpeechEnabled_ = false;
  @Prop({ default: [] }) deliveryOptions: Array<DeliveryOption> | undefined;

  mounted() {
    this.updateData();

    new ResizeObserver(this.manageSectionDivider).observe(this.$el.querySelector('#scrolling-tools'));
  }

  @Watch('deliveryOptions')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange(newItem: Array<DeliveryOption>) {
    this.updateData();
  }

  private get basicEnabled(): boolean {
    return this.basicOptionEnabled('basic-calculator');
  }

  private get scientificEnabled(): boolean {
    return this.basicOptionEnabled('scientific-calculator');
  }

  private get graphingEnabled(): boolean {
    return this.basicOptionEnabled('graphing-calculator');
  }

  private basicOptionEnabled(name: string): boolean {
    return this.basicDeliveryOptions.findIndex((option) => option.name === name) != -1;
  }

  private adjustForFocusMode(): boolean {
    return DeliveryOptionUtility.getDeliveryOptionAndCheckExpectedValue(
      this.deliveryOptions,
      DeliveryOptionConstants.FOCUS_MODE,
      'value',
      'true'
    );
  }

  private textToSpeechEnabled(): boolean {
    return this.textToSpeechEnabled_;
  }
  private get basicDeliveryOptions(): Array<DeliveryOption> {
    return this.basicDeliveryOptions_;
  }

  private getIconClass(deliveryOption: DeliveryOption): string {
    return 'fa-' + this.toolManager!.getIconClass(deliveryOption.name);
  }

  private getButtonTitle(deliveryOption: DeliveryOption): string {
    return this.toolManager!.getTitle(deliveryOption.name);
  }

  private updateData(): void {
    this.basicDeliveryOptions_ = this.deliveryOptions!.filter((option) => option.type === DeliveryOptionType.BASIC);
    const textToSpeechDeliveryOption: DeliveryOption | undefined = DeliveryOptionUtility.getDeliveryOption(
      this.deliveryOptions,
      DeliveryOptionConstants.TEXT_TO_SPEECH
    );
    this.textToSpeechEnabled_ = textToSpeechDeliveryOption !== undefined;
  }

  private manageSectionDivider(): void {
    const scrollingTools = this.$el.querySelector('#scrolling-tools');
    const innerContainer = this.$el.querySelector('#inner-container');
    const fixedTools = this.$el.querySelector('#fixed-tools');

    if (scrollingTools && innerContainer && fixedTools) {
      fixedTools.classList.remove('fixed-tools-divider');
      if (this.textToSpeechEnabled_ && scrollingTools.scrollWidth - 1 < innerContainer.clientWidth) {
        fixedTools.classList.add('fixed-tools-divider');
      }
    }
  }
}
